
import { createContext, useReducer } from "react";
import ActionEnvoieReducer from "./ActionEnvoieReducer";

const INITIAL_STATE = {
    actionsEnvois: [],
    count: 1,
    isFetching: false,
    error: false,
    actionEnvoie: {},
    isFetchingAdd: false,
    errorAdd: false,
    actionEnvoieUpdate: {},
    isFetchingUpdate: false,
    errorUpdate: false,
    isFetchingGet: false,
    errorGet: false,
};


export const ActionEnvoieContext = createContext(INITIAL_STATE);

export const ActionEnvoieContextProvider = ({ children }) => {
    const [state, dispatch] = useReducer(ActionEnvoieReducer, INITIAL_STATE);
    
    return (
      <ActionEnvoieContext.Provider
        value={{
          actionsEnvois: state.actionsEnvois,
          count: state.count,
          isFetching: state.isFetching,
          error: state.error,
          actionEnvoie: state.actionEnvoie,
          isFetchingAdd: state.isFetchingAdd,
          errorAdd: state.errorAdd,
          actionEnvoieUpdate: state.actionEnvoieUpdate,
          isFetchingUpdate: state.isFetchingUpdate,
          errorUpdate: state.errorUpdate,
          isFetchingGet: state.isFetchingGet,
          errorGet: state.errorGet,
          dispatch,
        }}
      >
        {children}
      </ActionEnvoieContext.Provider>
    );
  };